module.exports = __webpack_public_path__ + "static/img/initiative2.4d3d4a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/initiative2.png
// module id = 6eHR
// module chunks = 1